<template>
  <div class="d-flex">
    <div>
      <div class="b-red pos-rel" style="width: 400px; height: 400px">
        <ModelFacade ref="modelFacade" :modelIndex="`cat`" :size="400"></ModelFacade>
      </div>

      <div class="d-flex">
        <div v-for="(id, i) in buttons" :key="i">
          <v-btn @click="onTest(id)" small>{{ id }}</v-btn>
        </div>
      </div>
    </div>

    <div>
      <div class="b-blue pos-rel" style="width: 400px; height: 400px">
        <div class="text-caption-wrapper">
          <TextCaption ref="textCaption" @captionEnd="onCaptionEnd"></TextCaption>
        </div>
      </div>
      <div>
        <v-btn @click="onClickOneCaptionStart" small>caption start</v-btn>
        <v-btn @click="onClickOneCaptionStop" small>caption stop</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// TODO:
// Text Caption 다듬기
// 1000초 뒤에 꺼지기
// 근데 그전에 무언가 텍스트가 더 들어오면
// 다 재생하고 1000초 뒤에 꺼져야 됨.

const virtupetProfile = {
  id: 1,
  name: "우주몽지",
  planet: "수성 (Mercury)",
  age: 96,
  gender: "여성",
  job: "교사",
  created_at: "2024-03-06T04:07:06.231638+00:00",
  updated_at: null,
};

export default {
  data() {
    return {
      buttons: ["introduce-type1", "introduce-type2"],
    };
  },
  methods: {
    onTest(id) {
      // model facade는 재생만 해야되고 여기서 끝나야 한다.
      // 안쪽에서는 아무것도 몰라야 한다
      const context = {
        // uuid
        // 생성시각
        virtupetProfile,
        donation: {
          fromUser: "만수르",
          amount: 10000,
        },
        chat: {},
      };
      this.$refs.modelFacade.playAction(id, context);
    },
    // caption setting
    onClickOneCaptionStart() {
      const text = [
        "안녕하세요 {{name}}(이)에요, 저는 {{planet}}에서 여러분을 만나러 왔어요. 저는 {{age}}살 입니다. 저와 대화하시려면 [[{{name}}]] 안녕이라고 해주세요",
      ];
      this.$refs.textCaption.play(text);
    },
    onClickOneCaptionStop() {
      this.$refs.textCaption.stop();
    },
    onCaptionEnd() {
      console.log("end");
    },
  },
};
</script>

<style scoped>
.text-caption-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 120px;
}
</style>
